import { callEndpoint } from './apiUtils';
import 'whatwg-fetch';

export const medicalGroupApi = async (token: string) => {
  const response: MedicalGroupResponse = await callEndpoint<MedicalGroupResponse>(
    `medicalgroup?token=${token}`,
    '',
    'GET'
  );
  return response;
};
